<div *ngIf="!showCommonPopup" class="common-popup">
  <div class="modal-header">
    <h2 class="page-title">Confirm</h2>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="nav-white-box">
    <div class="container-fluid">
      <div>{{confirmText}}</div>
    </div>
    <div>
      <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="btn btn-ornge pull-right" style="height: 36px;width: 130px;margin-right: 15px;">OK</button>
        <button mat-button mat-dialog-close class="btn btn-gray" style="height: 36px;width: 130px;margin-right: 15px;">Cancel</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
<div *ngIf="showCommonPopup" class="custom-common-popup">
  <div class="modal-header">
    <h4 class="modal-title page-title">Confirmation</h4>
  </div>
  <div class="modal-body nav-white-box">
    <div class="container-fluid">
      <p>{{confirmText}}</p>
    </div>
    <div>
      <mat-dialog-actions align="end" class="modal-footer">
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="btn btn-ornge pull-right">Confirm</button>
        <button *ngIf="showOnlyConfirmButton == false" mat-button mat-dialog-close class="btn btn-gray">Cancel</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>